<subscription-page
  [subscription]="subscription()"
  [reportedStatus]="reportedStatus()"
  [isLoading]="isLoading()"
  [isNotFound]="isNotFound()"
  [isNotAuthorized]="isNotAuthorized()"
>
  @if (subscription(); as sub) {
    <l3vpn-subscription-view
      [subscription]="sub"
      [activities]="activities()"
      [activeTab]="activeTab()"
      (tabChange)="changeActiveTab($event)"
    />
  }
</subscription-page>
